module.exports = __webpack_public_path__ + "img/rock-huge-08.edef7127.png";